// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlApiVideos: {
    //url: 'http://localhost:53017',
    //url: 'http://192.168.0.19/PortalGrabaciones', ///********************pruebas */
    //url:'http://192.168.0.37/PortalGrabaciones',
    //url:'http://192.168.0.248/PortalGrabaciones',
    //url para local ******************
    //url:'http://apigrabaciones.ramajudicial.gov.co/PortalGrabaciones',//Url antigua de maqueta de Mao
    url:'https://apigrabacionescsj.calltechsa.com/PortalGrabaciones',
    //*************************
    //url para maqueta ******************
    //url:'https://apigrabaciones.ramajudicial.gov.co',
    //*************************
    //url: 'https://vctlogserver.calltechsa.com/PortalGrabaciones',
    //url: 'http://192.168.0.19/TECGO.PortalGrabaciones.WebApi',
    //url:'http://apigestionaudiencias1.ramajudicial.gov.co',
    //url:'https://apigestionaudiencias1.ramajudicial.gov.co',
    // url: 'http://172.27.64.25/Api',
    //url: 'http://ctlogbotmsteams.southcentralus.cloudapp.azure.com/TECGO.PortalGrabaciones.WebApi/',
    //backAuthurl: 'http://200.119.47.226:9001',
    //url para local ******************
    //backAuthurl: 'http://apigestionaudiencias3.ramajudicial.gov.co:9001', //Url antigua de maqueta de william
    backAuthurl: 'https://apimaquetacsj.calltechsa.com:9002',
    //*************************
    //url para maqueta ******************
    //backAuthurl: 'https://apiagendamiento.ramajudicial.gov.co',
    //*************************
    user: 'USR_A3FAA51025C84819A4ABF550DB4A3ECF',
    password: 'D1B2290324EA479A8AB74B92EE1A82FC'
  },
  title: 'Gestión de videos',
  pageSizes: [10, 30, 50],
  urlApiIP: "https://api.ipify.org/?format=json",
  modules: {
    home: 106,
    list_share: 107,
    transliterator: 108,
    statistics: 109,
    detail: 110,
    download: 111,
    tags: 112,
    attachments: 113,
    tagsvideo: 114,
    logs:115,
    ruta_dinamica:116,
    edit:117,
    navigate_transcription:118,
    deactivate:119,
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
